import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import MessagePreferencesSideDrawerContent from '../ProfilesRootScreen/ProAppProfilesRoot/AdminProfilesRoot/MessagePreferencesSideDrawerContent';

export type MessagePreferencesScreenOwnProps = {};

export type MessagePreferencesScreenProps = MessagePreferencesScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'message-preferences'>;
};

const MessagePreferencesScreen: React.FC<MessagePreferencesScreenProps> = ({
    route: {
        params: { selectedClientRecordIds },
    },
}) => {
    const goBack = useGoBack();

    return (
        <MessagePreferencesSideDrawerContent
            selectedClientRecordIds={selectedClientRecordIds}
            onClose={(_force) => {
                goBack();
            }}
        />
    );
};

export default React.memo(MessagePreferencesScreen);
